export default __webpack_public_path__ + "6a561dc88c37934054121c70b2579915.png";